import React from 'react';
import css from 'styled-jsx/css';
import I18nLink from '~/components/I18nLink';
import config from '~/config';
import { formatNumberWithCommas } from '~/utils/formatter';
import themeVariables from '~/shared/themeVariables';

const CategoryItem = ({ t, category, serviceType }) => {
  const {
    category_name: categoryName,
    category_slug: categorySlug,
    totalImages,
    topImages,
    categoryImage,
  } = category;
  let numberResults = null;
  if (totalImages >= 1000) {
    numberResults = Math.floor(totalImages / 1000) * 1000;
    numberResults = formatNumberWithCommas(numberResults);
  } else if (totalImages > 10) {
    numberResults = Math.floor(totalImages / 10) * 10;
    numberResults = parseInt(numberResults) + '';
  } else {
    numberResults = totalImages;
  }
  const imageURL = categoryImage || topImages[0].thumbnail;

  return (
    <article className="category-item">
      <I18nLink
        href={`/category/${categorySlug}`}
        host={serviceType && config.getSiteURL(serviceType)}
      >
        <a style={{ width: '100%' }} target="_blank" rel="noreferrer">
          <img
            className="large-item lazyload"
            data-src={imageURL}
            alt={categoryName}
          />
        </a>
      </I18nLink>
      <div className="content-category">
        <I18nLink
          as={`/category/${categorySlug}`}
          href={{
            pathname: `/category/${categorySlug}`,
          }}
          host={serviceType && config.getSiteURL(serviceType)}
        >
          <a className="category-name" target="_blank" rel="noreferrer">
            {categoryName}
          </a>
        </I18nLink>
        <div className="count-images">
          {t('category_number_results', { count: numberResults })}
        </div>
      </div>
      <style jsx>{styles}</style>
    </article>
  );
};

const styles = css`
  .category-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    border-radius: 4px;
    overflow: hidden;
  }

  .large-item {
    width: 100%;
    height: 286px;
    object-fit: cover;
  }
  .large-item:hover {
    opacity: 0.8;
  }

  .content-category {
    width: 100%;
    background: #ffffff;
    padding: 0 16px;
  }

  .category-name {
    width: 100%;
    height: 44px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;
    color: #1b2833;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .category-name:hover {
    color: ${themeVariables.colors.primary};
  }

  .count-images {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export default CategoryItem;
